export const APP_ID = "emblem-health-web";
export const APP_NAME = "Emblem Health";

export const TENANT_ID = "emblem-health";
export const AUTH0_CONNECTION =
  import.meta.env.VITE_AUTH0_CONNECTION || "emblem-health-saml";

export enum QUERY_PARAM_KEYS {
  MODAL = "modal",
}

export enum QUERY_PARAM_MODAL_VALUE {
  REMOVE_PERSONALIZATION = "remove-personalization",
  PERSONALIZATION_REMOVED_DISCLAIMER = "personalization-removed-disclaimer",
}

export const SECONDARY_CONTENT_MAX_WIDTH = "530px";

export const MASONRY = {
  // Web-only tree with the trailing sidebar; native apps keep `homePage$root`.
  ROOT_NODE_ID_HOME_PAGE: "homePage$rootWeb",
  ROOT_NODE_ID_CARE_LANDING_PAGE: "careLandingPage$root",
  ROOT_NODE_ID_PRIOR_AUTHORIZATIONS: "authorizations$root",
  // Matches Android emblem's `PreAuthorizationsMasonryRootIds(detailsId =
  // "authorizationsDetails$root")` in `EmblemhealthApplication.kt:443`. The
  // SDK's `PreAuthorizationDetailsPage` reads `authorizationId` from the
  // query string and forwards it as an initial query param to this Masonry
  // tree, so the BE serves the per-authorization details view.
  ROOT_NODE_ID_PRIOR_AUTHORIZATIONS_DETAILS: "authorizationsDetails$root",
  ROOT_NODE_ID_CARE_PLANS: "carePlans$root",
  ROOT_NODE_ID_FORMS_PAGE: "formsPage$root",
  ROOT_NODE_ID_CARE_MANAGEMENT_FORM: "careManagementForm$root",
  ROOT_NODE_ID_MEDICATION_COVERAGE_FORM: "medicationCoverageForm$root",
  ROOT_NODE_ID_COB_INTERSTITIAL: "cobInterstitial$root",
  ROOT_NODE_ID_MEDICATION_COVERAGE_INTERSTITIAL:
    "medicationCoverageInterstitial$root",
  ROOT_NODE_ID_COB_FORM: "cobForm$root",
  ROOT_NODE_ID_PRE_AUTHORIZATION_INTERSTITIAL:
    "preAuthorizationInterstitial$root",
  ROOT_NODE_ID_PRE_AUTHORIZATION_FORM: "preAuthorizationForm$root",
  ROOT_NODE_ID_PRE_AUTHORIZATION_CHECK_TOOL: "preAuthorizationCheckTool$root",
  ROOT_NODE_ID_PRE_AUTHORIZATION_CHECK_TOOL_RESULT:
    "preAuthorizationCheckTool$result$root",
  ROOT_NODE_ID_STUDENT_CERTIFICATION_FORM: "studentCertificationForm$root",
  ROOT_NODE_ID_SUBMISSION_CONFIRMATION: "submissionConfirmation$root",
  ROOT_NODE_ID_SUPPORT: "support$root",
  ROOT_NODE_ID_PLAN_MEMBER_SELECTOR:
    "planMemberSelector$planMemberSelectorRoot",
  ROOT_NODE_ID_BILLING_AND_PAYMENTS: "billingAndPayments$root",
  ROOT_NODE_ID_COMMUNICATION_PREFERENCES: "communicationPreferences$root",
  ROOT_NODE_ID_COMMUNICATION_PREFERENCES_NOTIFICATIONS:
    "communicationPreferences$notifications$root",
  ROOT_NODE_ID_COMMUNICATION_PREFERENCES_DOC_PREFS_SUCCESS:
    "communicationPreferences$documentPreferencesSuccess$root",
  ROOT_NODE_ID_COMMUNICATION_PREFERENCES_NOTIFICATIONS_SUCCESS:
    "communicationPreferences$notifications$notificationsAlertPreferencesSuccess$root",
  ROOT_NODE_ID_MY_PROFILE: "myProfile$root",
  ROOT_NODE_ID_MY_PROFILE_PERSONAL_INFORMATION:
    "myProfilePersonalInformation$root",
  ROOT_NODE_ID_MY_PROFILE_ADDRESS: "myProfileAddress$root",
  ROOT_NODE_ID_MY_PROFILE_PHONE_AND_EMAIL: "myProfilePhoneAndEmail$root",
} as const;

export const DETAIL = {
  CONTINUE: "continue",
  CANCEL: "cancel",
  CONFIRM_DELETION: "confirm deletion",
  ACKNOWLEDGE_DELETION: "acknowledge deletion",
  NAVIGATE_TO_HOME: "Navigate to Home page",
  START_HEALTH_ASSESSMENT: "start health assessment",
  SKIP_HEALTH_ASSESSMENT: "skip health assessment",
  OPT_IN_PAPERLESS: "opt in to paperless",
  NOT_NOW: "not now",
} as const;

export const ANALYTICS_SCREEN_NAMES = {
  SIGN_IN: "sign in",
  COMPLETE_ONBOARDING: "complete onboarding",
  GENERIC_ERROR: "generic error",
  DELETION_CONFIRMATION: "deletion confirmation",
  DELETE_ACCOUNT: "delete account",
  HEALTH_JOURNEY_DISCLAIMER: "health journey disclaimer",
  GO_PAPERLESS: "go paperless",
} as const;

export const SUB_PRODUCT_AREA_NAMES = {
  SIGN_IN: "sign in",
  ONBOARDING: "onboarding",
  ACCOUNT_SETUP: "account setup",
} as const;

export const PRODUCT_AREA_NAMES = {
  HOME: "home",
  FOUNDATION: "foundation",
} as const;
